<template>
    <div>
        <form id="update_card_to_card_form" class="bg-white p-3 rounded">
            <kt-form-section is_first style="margin-top: 30px">
                <kt-row>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="farsi_name">
                                {{ $t('label.farsi_name') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                id="farsi_name"
                                name="farsi_name"
                                v-model="card_to_card.farsi_name"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>

                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="english_name">
                                {{ $t('label.english_name') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                id="english_name"
                                name="english_name"
                                v-model="card_to_card.english_name"
                                dir="ltr"

                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
            </kt-form-section>

            <kt-form-section>
                <kt-row>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="website">
                                {{ $t('label.website_address') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                id="website"
                                name="website"
                                v-model="card_to_card.website"
                                dir="ltr"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="server_ip">
                                {{ $t('label.server_ip') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                id="server_ip"
                                name="server_ip"
                                v-model="card_to_card.server_ip"
                                dir="ltr"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="callback_address">
                                {{ $t('label.callback_address') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <kt-form-control
                                id="callback_address"
                                name="callback_address"
                                v-model="card_to_card.callback_address"
                                dir="ltr"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-if="card_to_card.need_monthly_recharge" lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="recharge_expire_date">
                                {{ $t('card_to_card.recharge_expire_date') }}
                            </kt-form-label>
                            <kt-form-control
                                id="recharge_expire_date"
                                name="recharge_expire_date"
                                disabled
                                v-model="card_to_card.recharge_expire_date"
                                dir="ltr"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="wage">
                                {{ $t('label.wage') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>

                            <select
                                id="wage"
                                name="wage"
                                v-model="wage"
                                class="form-control kt-selectpicker1"
                            >
                                <option
                                    v-for="wage_data in wages"
                                    v-bind:key="wage_data.id"
                                    :value="wage_data.id"
                                >
                                    {{ wage_data.value }}
                                </option>
                            </select>
                        </kt-form-group>
                    </kt-col>

                    <kt-col v-show="wage == 50" id="merchant_wage_share_column" lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="merchant_wage_share">
                                {{ $t('label.merchant_wage_share') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <input
                                type="number"
                                max="100"
                                min="0"
                                id="merchant_share_percent"
                                name="merchant_share_percent"
                                v-model="card_to_card.merchant_share_percent"
                                class="form-control kt-selectpicker"
                                @change="changeWagePercent"
                            >
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="wage == 50" id="client_wage_share_column" lg="3" md="3" xs="12">
                        <kt-form-group>
                            <kt-form-label for="client_share_percent">
                                {{ $t('label.client_wage_share') }}<span style="color: red">{{ ' *' }}</span>
                            </kt-form-label>
                            <input
                                type="number"
                                max="100"
                                min="0"
                                id="client_share_percent"
                                name="client_share_percent"
                                disabled
                                class="form-control kt-selectpicker"
                            >
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12">
                        <label>
                            {{ $t("label.logo") }}
                        </label>
                        <label
                            for="logo_file"
                            class="d-block btn btn-secondary btn-wide label-file"
                        >
                            <kt-icon type="fa" name="paperclip"></kt-icon>
                            {{ $t("gateway.btn.click_me") }}
                        </label>
                        <input
                            @change="processLogoFile"
                            type="file"
                            class="custom-file-upload d-none"
                            name="logo"
                            id="logo_file"
                            accept="image/*"
                        />
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12" class="d-flex justify-content-start">
                        <img :src="picPreview" class="preview_picture" v-if="picPreview !== ''"/>
                        <i class="fa fa-window-close text-danger remove_picture" v-if="picPreview !== ''"
                           @click="removePicture"></i>
                    </kt-col>
                </kt-row>
            </kt-form-section>
            <kt-form-action class="mt-4" style="margin-top: 20px!important;text-align: end!important;">
                <kt-button
                    class="btn-wide"
                    size="md"
                    @click="update"
                    variant="success"
                    v-bind:wide="true"
                    id="submit_btn"
                >
                    {{ $t('btn.edit') }}
                </kt-button>
            </kt-form-action>
        </form>
    </div>
</template>

<script>
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import {cardToCardService} from '@/common/api.service'
import {KTApp} from '@/plugins/core/app'
import {cardToCardStatus} from '@/constants/cardToCard'
import toastr from "toastr";

export default {
    components: {},
    props: {
        card_to_card: {
            default() {
                return {}
            },
            type: Object
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
    data() {
        return {
            new_card: {},
            cardToCardStatus,
            picPreview: '',
            wage: null,
            wages: [
                {
                    id: 0,
                    value: this.$t('gateway.wages.from_payer')
                },
                {
                    id: 100,
                    value: this.$t('gateway.wages.from_me')
                },
                {
                    id: 50,
                    value: this.$t('gateway.wages.half')
                }
            ],
        }
    },
    mounted() {
        this.picPreview = this.card_to_card.logo_url
        if (this.card_to_card.merchant_share_percent === 0)
            this.wage = 0
        else if (this.card_to_card.merchant_share_percent === 100)
            this.wage = 100
        else
            this.wage = 50

        this.afterDispatch();
    },
    watch: {
        wage: function (wage) {
            if (wage == 0) {
                this.card_to_card.merchant_share_percent = 0
                let client_share_percent = $('#client_share_percent')
                client_share_percent.val(0)
            } else if (wage == 50) {
                if (this.card_to_card.merchant_share_percent == 100 || this.card_to_card.merchant_share_percent == 0) {
                    this.card_to_card.merchant_share_percent = 50
                    let client_share_percent = $('#client_share_percent')
                    client_share_percent.val(50)
                } else {
                    let client_share_percent = $('#client_share_percent')
                    client_share_percent.val(100 - this.card_to_card.merchant_share_percent)
                }
            } else if (wage == 100) {
                this.card_to_card.merchant_share_percent = 100
                let client_share_percent = $('#client_share_percent')
                client_share_percent.val(100)
            }
        }
    },
    methods: {
        afterDispatch() {
            setTimeout(function () {
                $('.kt-selectpicker1').selectpicker({
                    size: 4,
                    liveSearch: false,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            }, 100);
        },
        update() {
            let form = $('#update_card_to_card_form');
            let btn = $('#submit_btn');

            form.validate({
                rules: {
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    website: {
                        required: true,
                    },
                    callback_address: {
                        required: true,
                    },
                    merchant_share_percent: {
                        required: true,
                        maxlength: 100,
                        minlength: 0,
                        number: true
                    },
                }
            });

            if (!form.valid()) {
                return;
            }

            KTApp.progress(btn);
            let params = {
                farsi_name: this.card_to_card.farsi_name,
                english_name: this.card_to_card.english_name,
                callback_address: this.card_to_card.callback_address,
                website: this.card_to_card.website,
                server_ip: this.card_to_card.server_ip,
                logo: this.card_to_card.logo ? this.card_to_card.logo : '',
                merchant_share_percent: this.card_to_card.merchant_share_percent
            };

            cardToCardService.update(this.card_to_card.id, params).then(response => {
                this.showMsg(form, 'success', response.data.message)
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
                for (let err in response.data.data) {
                    this.showMsg(form, 'danger', response.data.data[err][0]);
                }
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        processLogoFile(e) {
            this.card_to_card.logo = event.target.files[0];
            this.picPreview = URL.createObjectURL(e.target.files[0]);
            if (this.validateSize(event.target)) {
                this.validateFormat(event.target);
            }
        },
        removePicture() {
            this.picPreview = ''
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, "");
            if (extension === file_name) {
                extension = "";
            } else {
                extension = extension.toLowerCase();
            }

            switch (extension) {
                case "png":
                case "jpeg":
                case "jpg":
                    break;
                default:
                    alert(i18n.t("authenticate.input_format_err"));
                    $(file).val("");
                    this.card_to_card.logo = null;
                    return false;
            }

            return true;
        },
        validateSize(file) {
            var FileSize = file.files[0].size / 1024 / 1024; // in MB
            if (FileSize > 1) {
                alert(i18n.t("authenticate.hint.fourth"));
                $(file).val("");
                this.card_to_card.logo = null;
                return false;
            }

            return true;
        },
        changeWagePercent() {
            if (this.wage != 50)
                return;
            let client_share_percent = $('#client_share_percent')
            client_share_percent.val(100 - this.card_to_card.merchant_share_percent)
        },
    },
}
</script>

<style scoped>
.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}

input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}

.preview_picture {
    width: 50%;
    height: 150px;
}

.remove_picture {
    cursor: pointer;
    position: absolute;
    top: -5px;
}
</style>